module.exports = __webpack_public_path__ + "static/media/close-black.52f1b8d2.svg";